export default __webpack_public_path__ + "static/media/button_align_right.c1539cb2.svg";